<!-- <div class="loader-backdrop">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div> -->
<router-outlet />
@if (isLoading) {
  <app-spinner [loader_message]="message"></app-spinner>
}
